module.exports = __webpack_public_path__ + "assets/294ae9818135ba957afbe64ea0bdc83f.png";